import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { FileText, Download, FileBarChart, Receipt, Landmark, ScrollText } from "lucide-react";
import {
  Table, TableBody, TableCell, TableHead, TableHeader, TableRow,
} from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";

const typeIcon = { Report: FileBarChart, Tax: Receipt, Strategy: Landmark, Advisory: ScrollText };

export default function Documents() {
  const [docs, setDocs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/portal/documents").then(({ data }) => setDocs(data)).finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="portal-documents">
      <div className="mb-8">
        <p className="overline text-primary">Documents & Reports</p>
        <h1 className="font-serif text-4xl text-slate-900 mt-1">Your secure library</h1>
        <p className="text-slate-500 mt-2">Statements, reports and strategy documents shared by your advisor.</p>
      </div>

      <div className="rounded-2xl border border-border bg-white overflow-hidden">
        <Table>
          <TableHeader>
            <TableRow className="bg-[#f4f7fd]">
              <TableHead className="w-1/2">Document</TableHead>
              <TableHead>Type</TableHead>
              <TableHead>Date</TableHead>
              <TableHead>Size</TableHead>
              <TableHead className="text-right">Action</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {loading ? (
              <TableRow><TableCell colSpan={5} className="text-center py-10 text-slate-400">Loading…</TableCell></TableRow>
            ) : docs.length === 0 ? (
              <TableRow><TableCell colSpan={5} className="text-center py-10 text-slate-400">No documents yet.</TableCell></TableRow>
            ) : (
              docs.map((d) => {
                const Icon = typeIcon[d.type] || FileText;
                return (
                  <TableRow key={d.id} data-testid={`doc-row-${d.id}`} className="hover:bg-[#f8fafc]">
                    <TableCell>
                      <div className="flex items-center gap-3">
                        <div className="h-9 w-9 rounded-lg bg-accent text-primary flex items-center justify-center"><Icon size={16} /></div>
                        <span className="font-medium text-slate-800">{d.name}</span>
                      </div>
                    </TableCell>
                    <TableCell><Badge variant="secondary" className="font-normal">{d.type}</Badge></TableCell>
                    <TableCell className="text-slate-500">{d.date}</TableCell>
                    <TableCell className="text-slate-500">{d.size}</TableCell>
                    <TableCell className="text-right">
                      <button
                        data-testid={`doc-download-${d.id}`}
                        onClick={() => toast.info("A secure download link has been sent to your email.")}
                        className="inline-flex items-center gap-1.5 text-sm font-medium text-primary hover:underline"
                      >
                        <Download size={15} /> Download
                      </button>
                    </TableCell>
                  </TableRow>
                );
              })
            )}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
